function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1960(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 28.6,
    height: 15.96,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.2800000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.3,
    y: 7.98
  }, "\n        Tyrrell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 15.96,
    width: 28.6,
    height: 16.93,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.8216666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.3,
    y: 24.425
  }, "\n        Camden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 32.89,
    width: 28.6,
    height: 20.38,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.095
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.3,
    y: 43.08
  }, "\n        Hyde\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 53.28,
    width: 28.6,
    height: 24.22,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.843999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.3,
    y: 65.39
  }, "\n        Gates\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 77.49,
    width: 28.6,
    height: 26.26,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.6260000000000003
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.3,
    y: 90.61999999999999
  }, "\n        Perquimans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 103.75,
    width: 28.6,
    height: 26.48,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.942222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.3,
    y: 116.99
  }, "\n        Currituck\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 130.23,
    width: 28.6,
    height: 28.86,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.15
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.3,
    y: 144.66
  }, "\n        Dare\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 159.09,
    width: 28.6,
    height: 30.71,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.766666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.3,
    y: 174.445
  }, "\n        Chowan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 189.8,
    width: 28.6,
    height: 31.36,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.720000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.3,
    y: 205.48000000000002
  }, "\n        Jones\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 221.17,
    width: 28.6,
    height: 33.83,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.15
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.3,
    y: 238.08499999999998
  }, "\n        Hoke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 255,
    width: 28.6,
    height: 34.53,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.085714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.3,
    y: 272.265
  }, "\n        Pamlico\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 289.53,
    width: 28.6,
    height: 36.57,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.15
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.3,
    y: 307.815
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 326.1,
    width: 28.6,
    height: 38.26,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.766666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.3,
    y: 345.23
  }, "\n        Graham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 364.37,
    width: 28.6,
    height: 43.1,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.8600000000000003
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.3,
    y: 385.92
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 407.46,
    width: 28.6,
    height: 44.36,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.766666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.3,
    y: 429.64
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 451.83,
    width: 28.6,
    height: 46.5,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.766666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.3,
    y: 475.08
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 498.33,
    width: 28.6,
    height: 48.66,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.3,
    y: 522.66
  }, "\n        Hertford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 546.98,
    width: 28.6,
    height: 50.31,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.766666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.3,
    y: 572.135
  }, "\n        Pender\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 597.29,
    width: 28.6,
    height: 51.32,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.177777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.3,
    y: 622.9499999999999
  }, "\n        Alleghany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 648.61,
    width: 28.6,
    height: 51.39,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.085714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.3,
    y: 674.3050000000001
  }, "\n        Caswell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.6,
    y: 0,
    width: 35.92,
    height: 42.45,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.986666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 46.56,
    y: 21.225
  }, "\n        Bertie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 64.52,
    y: 0,
    width: 36.13,
    height: 42.45,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.226000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 82.585,
    y: 21.225
  }, "\n        Swain\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100.64,
    y: 0,
    width: 41.51,
    height: 42.45,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.18875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 121.395,
    y: 21.225
  }, "\n        Scotland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 142.16,
    y: 0,
    width: 44.05,
    height: 42.45,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.49
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 164.185,
    y: 21.225
  }, "\n        Avery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 186.21,
    y: 0,
    width: 45.83,
    height: 42.45,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.8590909090909093
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 209.125,
    y: 21.225
  }, "\n        Northampton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 232.04,
    y: 0,
    width: 47.39,
    height: 42.45,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.6125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 255.73499999999999,
    y: 21.225
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 279.43,
    y: 0,
    width: 48.22,
    height: 42.45,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.49
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 303.54,
    y: 21.225
  }, "\n        Anson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 327.65,
    y: 0,
    width: 50.65,
    height: 42.45,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.30625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 352.97499999999997,
    y: 21.225
  }, "\n        Mitchell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 378.3,
    y: 0,
    width: 52.2,
    height: 42.45,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.30625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 404.40000000000003,
    y: 21.225
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 430.5,
    y: 0,
    width: 52.35,
    height: 42.45,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 456.675,
    y: 21.225
  }, "\n        Bladen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 482.85,
    y: 0,
    width: 52.56,
    height: 42.45,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 509.13,
    y: 21.225
  }, "\n        Person\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 535.41,
    y: 0,
    width: 53.62,
    height: 42.45,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.245
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 562.2199999999999,
    y: 21.225
  }, "\n        Pasquotank\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 589.03,
    y: 0,
    width: 55.36,
    height: 42.45,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 616.7099999999999,
    y: 21.225
  }, "\n        Martin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 644.38,
    y: 0,
    width: 55.62,
    height: 42.45,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 672.1899999999999,
    y: 21.225
  }, "\n        Yancey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.6,
    y: 42.45,
    width: 53.32,
    height: 45.28,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.0311111111111115
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.260000000000005,
    y: 65.09
  }, "\n        Granville\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.6,
    y: 87.73,
    width: 53.32,
    height: 45.88,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.176
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.260000000000005,
    y: 110.67
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.6,
    y: 133.61,
    width: 53.32,
    height: 46.64,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.664
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.260000000000005,
    y: 156.93
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.6,
    y: 180.25,
    width: 53.32,
    height: 48.48,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.386666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.260000000000005,
    y: 204.49
  }, "\n        Brunswick\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.6,
    y: 228.73,
    width: 53.32,
    height: 48.59,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.19666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.260000000000005,
    y: 253.02499999999998
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.6,
    y: 277.32,
    width: 53.32,
    height: 48.74,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.748000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.260000000000005,
    y: 301.69
  }, "\n        Davie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.6,
    y: 326.06,
    width: 53.32,
    height: 50.3,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.2875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.260000000000005,
    y: 351.21
  }, "\n        Cherokee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.6,
    y: 376.36,
    width: 53.32,
    height: 51.09,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.2575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.260000000000005,
    y: 401.90500000000003
  }, "\n        Transylvania\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.6,
    y: 427.45,
    width: 53.32,
    height: 51.74,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.348
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.260000000000005,
    y: 453.32
  }, "\n        Vance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.6,
    y: 479.19,
    width: 53.32,
    height: 53.16,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.594285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.260000000000005,
    y: 505.77
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.6,
    y: 532.35,
    width: 53.32,
    height: 54.6,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.924444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.260000000000005,
    y: 559.65
  }, "\n        Alexander\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.6,
    y: 586.95,
    width: 53.32,
    height: 56.24,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.886666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.260000000000005,
    y: 615.07
  }, "\n        Onslow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.6,
    y: 643.19,
    width: 53.32,
    height: 56.81,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.617142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.260000000000005,
    y: 671.595
  }, "\n        Watauga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.92,
    y: 42.45,
    width: 55.91,
    height: 55.93,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.98875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 109.875,
    y: 70.415
  }, "\n        Beaufort\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 137.83,
    y: 42.45,
    width: 57.41,
    height: 55.93,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.99
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 166.53500000000003,
    y: 70.415
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 195.24,
    y: 42.45,
    width: 57.56,
    height: 55.93,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.99
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 224.02,
    y: 70.415
  }, "\n        Chatham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 252.8,
    y: 42.45,
    width: 59.54,
    height: 55.93,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.9825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 282.57,
    y: 70.415
  }, "\n        Ashe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 312.34,
    y: 42.45,
    width: 59.92,
    height: 55.93,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.321666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 342.29999999999995,
    y: 70.415
  }, "\n        Stokes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 372.25,
    y: 42.45,
    width: 62.46,
    height: 55.93,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.99125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 403.48,
    y: 70.415
  }, "\n        Carteret\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 434.72,
    y: 42.45,
    width: 64.36,
    height: 55.93,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.321666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 466.90000000000003,
    y: 70.415
  }, "\n        Yadkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 499.07,
    y: 42.45,
    width: 65.44,
    height: 55.93,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.321666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 531.79,
    y: 70.415
  }, "\n        Duplin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 564.52,
    y: 42.45,
    width: 66.1,
    height: 55.93,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.214444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 597.5699999999999,
    y: 70.415
  }, "\n        Edgecombe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 630.62,
    y: 42.45,
    width: 69.38,
    height: 55.93,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.321666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 665.31,
    y: 70.415
  }, "\n        Craven\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.92,
    y: 98.38,
    width: 62.57,
    height: 63.16,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.82125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 113.205,
    y: 129.95999999999998
  }, "\n        McDowell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.92,
    y: 161.53,
    width: 62.57,
    height: 63.72,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.428333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 113.205,
    y: 193.39
  }, "\n        Wilson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.92,
    y: 225.25,
    width: 62.57,
    height: 64.17,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.938571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 113.205,
    y: 257.335
  }, "\n        Halifax\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.92,
    y: 289.42,
    width: 62.57,
    height: 65.02,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.514
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 113.205,
    y: 321.93
  }, "\n        Moore\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.92,
    y: 354.44,
    width: 62.57,
    height: 65.36,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.514
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 113.205,
    y: 387.12
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.92,
    y: 419.81,
    width: 62.57,
    height: 66.25,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.82125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 113.205,
    y: 452.935
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.92,
    y: 486.06,
    width: 62.57,
    height: 67.43,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.428333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 113.205,
    y: 519.775
  }, "\n        Lenoir\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.92,
    y: 553.49,
    width: 62.57,
    height: 71.02,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.428333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 113.205,
    y: 589
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.92,
    y: 624.51,
    width: 62.57,
    height: 75.49,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.938571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 113.205,
    y: 662.255
  }, "\n        Harnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.49,
    y: 98.38,
    width: 63.52,
    height: 75.13,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.704
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 176.25,
    y: 135.945
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 208.01,
    y: 98.38,
    width: 64.54,
    height: 75.13,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.22
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 240.28,
    y: 135.945
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 272.56,
    y: 98.38,
    width: 66.63,
    height: 75.13,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.6575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 305.875,
    y: 135.945
  }, "\n        Nash\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 339.19,
    y: 98.38,
    width: 67.24,
    height: 75.13,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.405
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 372.81,
    y: 135.945
  }, "\n        Columbus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 406.43,
    y: 98.38,
    width: 71.34,
    height: 75.13,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.191428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 442.1,
    y: 135.945
  }, "\n        Sampson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 477.77,
    y: 98.38,
    width: 72.45,
    height: 75.13,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.35
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 513.995,
    y: 135.945
  }, "\n        Robeson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 550.22,
    y: 98.38,
    width: 73.61,
    height: 75.13,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.178888888888888
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 587.025,
    y: 135.945
  }, "\n        Henderson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 623.83,
    y: 98.38,
    width: 76.17,
    height: 75.13,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 18.7825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 661.9150000000001,
    y: 135.945
  }, "\n        Pitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.49,
    y: 173.51,
    width: 86.22,
    height: 68.83,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.60375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 187.60000000000002,
    y: 207.92499999999998
  }, "\n        Johnston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.49,
    y: 242.34,
    width: 86.22,
    height: 69.05,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.864285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 187.60000000000002,
    y: 276.865
  }, "\n        Haywood\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.49,
    y: 311.38,
    width: 86.22,
    height: 72.87,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.287000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 187.60000000000002,
    y: 347.815
  }, "\n        Rutherford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.49,
    y: 384.25,
    width: 86.22,
    height: 75.66,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.132
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 187.60000000000002,
    y: 422.08
  }, "\n        Surry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.49,
    y: 459.91,
    width: 86.22,
    height: 78.08,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.675555555555555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 187.60000000000002,
    y: 498.95000000000005
  }, "\n        Cleveland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.49,
    y: 537.99,
    width: 86.22,
    height: 80.31,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.385
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 187.60000000000002,
    y: 578.145
  }, "\n        Stanly\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.49,
    y: 618.3,
    width: 86.22,
    height: 81.7,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.17
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 187.60000000000002,
    y: 659.15
  }, "\n        Cumberland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 230.71,
    y: 173.51,
    width: 89.82,
    height: 80.82,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.1025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 275.62,
    y: 213.92
  }, "\n        Caldwell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 320.52,
    y: 173.51,
    width: 91.53,
    height: 80.82,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.081999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 366.28499999999997,
    y: 213.92
  }, "\n        Rockingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 412.06,
    y: 173.51,
    width: 93.04,
    height: 80.82,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.469999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 458.58,
    y: 213.92
  }, "\n        Wilkes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 505.09,
    y: 173.51,
    width: 93.28,
    height: 80.82,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.545714285714284
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 551.73,
    y: 213.92
  }, "\n        Iredell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 598.38,
    y: 173.51,
    width: 101.62,
    height: 80.82,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.163999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 649.19,
    y: 213.92
  }, "\n        Burke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 230.71,
    y: 254.33,
    width: 106,
    height: 77.55,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.05
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 283.71000000000004,
    y: 293.105
  }, "\n        New_Hanover\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 230.71,
    y: 331.88,
    width: 106,
    height: 82.28,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 283.71000000000004,
    y: 373.02
  }, "\n        Cabarrus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 230.71,
    y: 414.16,
    width: 106,
    height: 86.34,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.7925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 283.71000000000004,
    y: 457.33000000000004
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 230.71,
    y: 500.5,
    width: 106,
    height: 95.99,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.99875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 283.71000000000004,
    y: 548.495
  }, "\n        Alamance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 230.71,
    y: 596.49,
    width: 106,
    height: 103.51,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 20.702
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 283.71000000000004,
    y: 648.245
  }, "\n        Rowan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 336.7,
    y: 254.33,
    width: 118.12,
    height: 96.74,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.0925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 395.76,
    y: 302.7
  }, "\n        Davidson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 454.82,
    y: 254.33,
    width: 120.75,
    height: 96.74,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.819999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 515.1949999999999,
    y: 302.7
  }, "\n        Catawba\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 575.57,
    y: 254.33,
    width: 124.43,
    height: 96.74,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.12333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 637.7850000000001,
    y: 302.7
  }, "\n        Durham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 336.7,
    y: 351.07,
    width: 140.77,
    height: 105.18,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.53
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 407.085,
    y: 403.65999999999997
  }, "\n        Gaston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 336.7,
    y: 456.26,
    width: 140.77,
    height: 113.15,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 28.2875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 407.085,
    y: 512.835
  }, "\n        Wake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 336.7,
    y: 569.41,
    width: 140.77,
    height: 130.59,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.32375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 407.085,
    y: 634.7049999999999
  }, "\n        Buncombe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 477.47,
    y: 351.07,
    width: 98.84,
    height: 207.96,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.120000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 526.89,
    y: 455.05
  }, "\n        Forsyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 576.31,
    y: 351.07,
    width: 123.69,
    height: 207.96,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.46125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 638.155,
    y: 455.05
  }, "\n        Guilford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 477.47,
    y: 559.04,
    width: 222.53,
    height: 140.96,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.814545454545454
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 588.735,
    y: 629.52
  }, "\n        Mecklenburg\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1960);
export default __webpack_public_path__ + "static/media/1960.939e8362287b4992289246cdce163f22.svg";
export { ForwardRef as ReactComponent };